import type { FC, ReactNode } from 'react'

import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { LegalPage } from '@/components/legal/legal-page'
import { company } from '@/constants/company'

const Impressum: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Impressum'
                path='/impressum'
                description='Impressum der BBA GmbH, Betreiberin der Marke ConcreTrack: Anschrift, Vertretung, Registereintrag und Kontakt.'
            />

            <LegalPage title='Impressum'>
                <h2>Angaben gemäß § 5 DDG</h2>

                <p>
                    {company.legalName}
                    <br />
                    {company.street}
                    <br />
                    {company.postalCode} {company.city}
                    <br />
                    {company.country}
                </p>

                <p>
                    Die {company.legalName} ist Betreiberin der Marke {company.brand}.
                </p>

                <h2>Vertreten durch</h2>

                <p>
                    Geschäftsführer: {company.managingDirector}
                </p>

                <h2>Kontakt</h2>

                <p>
                    Telefon: <a href={company.phoneHref}>{company.phone}</a>
                    <br />
                    E-Mail: <a href={`mailto:${company.email}`}>{company.email}</a>
                </p>

                <h2>Registereintrag</h2>

                <p>
                    Eintragung im Handelsregister
                    <br />
                    Registergericht: {company.registerCourt}
                    <br />
                    Registernummer: {company.registerNumber}
                </p>

                <h2>Umsatzsteuer-ID</h2>

                <p>
                    Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: {company.vatId}
                </p>

                <h2>Verbraucherstreitbeilegung</h2>

                <p>
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
            </LegalPage>
        </Layout>
    )
}

export default Impressum
